import request from './request'
import { CHECK_JIANSHU_LOGIN_URL, CHECK_LOGIN_URL } from './config'

/**
 * 检测用户是否已登录（两步）
 * 1. 先请求 CHECK_JIANSHU_LOGIN_URL（后端代理简书接口，避免 CORS），返回值里有 slug 表示简书已登录
 * 2. 用 slug 作为参数再请求 CHECK_LOGIN_URL，取 userInfo、balancePoints 等
 * @returns {Promise<{ loggedIn: boolean, user?: object, balancePoints?: number }>}
 */
export async function checkLogin () {
  try {
    const res = await request.get(CHECK_JIANSHU_LOGIN_URL, {})
    const slug = res && (res.slug != null ? res.slug : '')
     const mobile = res && (res.mobile != null ? res.mobile : '')
    if (slug == null || slug === '') {
      return { loggedIn: false }
    }
    const data = await request.post(CHECK_LOGIN_URL, res)
    if (data && data.loggedIn === false) return data
    if (data && data.userInfo != null) {
      const user = Object.assign({}, data.userInfo || data)
      const balancePoints = data.balancePoints != null ? data.balancePoints : (user.balancePoints != null ? user.balancePoints : 0)
      // 头像等字段有时在根级返回，合并进 user 供前端统一读取
      if (data.avatar != null && user.avatar == null) user.avatar = data.avatar
      return { loggedIn: true, user, balancePoints }
    }
    return { loggedIn: false }
  } catch (err) {
    return { loggedIn: false }
  }
}
